import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import {
  SortField,
  useCatalogFilterStore,
} from '@/stores/catalog-filter-store';

const SORT_OPTIONS: { field: SortField; label: string }[] = [
  { field: 'name', label: 'Name' },
  { field: 'price', label: 'Preis' },
  { field: 'stock', label: 'Verfügbarkeit' },
  { field: 'articleNumber', label: 'Artikelnummer' },
];

export function SortPanel() {
  const { sortField, sortDirection, setSortField } = useCatalogFilterStore();

  return (
    <Box sx={{ width: '100%' }}>
      <List disablePadding>
        <Box sx={{ py: 0.75, px: 1.5 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              fontSize: '0.8rem',
              textTransform: 'uppercase',
              letterSpacing: '0.03em',
              color: 'text.secondary',
            }}
          >
            Sortieren
          </Typography>
        </Box>
        <Divider />
        {SORT_OPTIONS.map(({ field, label }) => {
          const isActive = sortField === field;
          return (
            <ListItemButton
              key={field}
              selected={isActive}
              onClick={() => setSortField(field)}
              sx={{
                py: 0.5,
                px: 1.5,
                '&.Mui-selected': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '&:hover': { backgroundColor: 'primary.dark' },
                  '& .MuiTypography-root': { color: 'white' },
                },
              }}
            >
              <ListItemText
                primary={label}
                slotProps={{
                  primary: {
                    variant: 'body2',
                    sx: { fontSize: '0.8rem' },
                  },
                }}
              />
              {isActive &&
                (sortDirection === 'asc' ? (
                  <ArrowUpward sx={{ fontSize: 16 }} />
                ) : (
                  <ArrowDownward sx={{ fontSize: 16 }} />
                ))}
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
}
